import { numberComparatorForFormattedValues } from "utils/comparatorUtils";
import { NOTIFICATION_TABLE_COLUMNS, userProfileStrings } from "constants/constantStrings";

import NotificationCheckboxRenderer from "./NotificationCheckboxRenderer";
import NotificationsDeleteRenderer from "./NotificationsDeleteRenderer";

const getColConfigWithCheckbox = (field, flex = 1) => ({
  field,
  flex,
  editable: false,
  sortable: false,
  headerClass: "notificationsTableHeader",
  cellRendererParams: { field },
  cellRendererFramework: NotificationCheckboxRenderer
});

export const getNotificationTableConfig = (filter, admin, tier1) => [
  {
    field: "SystemName",
    headerName: NOTIFICATION_TABLE_COLUMNS.systemID,
    flex: 2,
    editable: false,
    filter
  },
  {
    field: "Email",
    headerName: NOTIFICATION_TABLE_COLUMNS.emailIDs,
    editable: false,
    flex: 1.75,
    filter,
    onCellValueChanged() {},
    headerClass: "notificationsTableHeader",
    hide: !admin
  },
  {
    field: "Mobile",
    headerName: NOTIFICATION_TABLE_COLUMNS.mobileNo,
    editable: false,
    flex: 1.50,
    filter,
    hide: !admin
  },
  {
    field: "Internal",
    headerName: NOTIFICATION_TABLE_COLUMNS.userType,
    editable: false,
    flex: 1.25,
    filter,
    valueFormatter: params => (params.data.Internal ? userProfileStrings.internalUser : userProfileStrings.externalUser),
    headerClass: "notificationsTableHeader",
    hide: !admin,
    comparator: numberComparatorForFormattedValues()
  },
  {
    field: "DisconnectDuration",
    headerName: NOTIFICATION_TABLE_COLUMNS.duration,
    editable: false,
    flex: 1.65,
    filter,
    valueFormatter: () => "1 min",
    headerClass: "notificationsTableHeader",
    headerTooltip: NOTIFICATION_TABLE_COLUMNS.disconnectedHeaderTootlip
  },
  {
    headerName: NOTIFICATION_TABLE_COLUMNS.statusAlert,
    ...getColConfigWithCheckbox("StatusAlert", 1.15)
  },
  {
    headerName: NOTIFICATION_TABLE_COLUMNS.alarmsAlert,
    ...getColConfigWithCheckbox("AlarmAlert", 1.25)
  },
  {
    headerName: NOTIFICATION_TABLE_COLUMNS.reportsAlert,
    ...getColConfigWithCheckbox("ReportAlert", 1.35)
  },
  {
    headerName: NOTIFICATION_TABLE_COLUMNS.insightsAlert,
    ...getColConfigWithCheckbox("InsightAlert", 1.35),
    hide: tier1
  },
  {
    colId: "delete",
    lockPinned: true,
    pinned: "right",
    editable: false,
    width: 50,
    cellRendererFramework: NotificationsDeleteRenderer,
    hide: !admin
  }
];
